import { Mileage, Currency } from '../commonRegex';
export const insert = (str, index, value) => str.substr(0, index) + value + str.substr(index);
export const handleMask = value => {
  let inputValue = value;
  if (inputValue.indexOf('.') > -1) {
    return inputValue;
  }
  if (value.indexOf(',') > -1) {
    inputValue = value.split(',').join('');
  }
  let {
    length
  } = inputValue;
  let mask = inputValue;
  while (length > 3) {
    mask = insert(mask, inputValue.length - 3, ',');
    length = inputValue.length - 3;
    inputValue = mask.substr(0, length);
  }
  if (mask.length === 0) {
    return value;
  }
  return mask;
};
export const handleMileage = value => {
  if (typeof value === 'undefined') {
    return;
  }
  if (!Mileage.test(value)) {
    return null;
  }
  const mask = handleMask(value);
  return mask;
};
export const handleCurrency = value => {
  if (typeof value === 'undefined') {
    return;
  }
  if (!Currency.test(value)) {
    return null;
  }
  let mask = '';
  mask = "".concat(handleMask(value.replace('$', '')));
  return "$".concat(mask);
};
//# sourceMappingURL=index.js.map